import { BasePromoClient, Promo } from "@core/types";
import { SupaPromo } from "../types/supabaseFragments";
import { convertParhato2Promo } from "./converters";

class PromoClient extends BasePromoClient {
  async getPromos(): Promise<Promo[] | null> {
    const { data } = await this.instance.get<SupaPromo[]>("/wp-json/parhato-api/v1/promos");
    return data ? data.map(convertParhato2Promo) : null;
  }

  async getPromoById(id: string): Promise<Promo | null> {
    const { data } = await this.instance.get<SupaPromo>(`/wp-json/parhato-api/v1/promos/${id}`);
    return data ? convertParhato2Promo(data) : null;
  }
}

export default PromoClient;
